import { Box, Button, Popover, Typography } from "@mui/material";
import { CalendarIcon, DateCalendar } from "@mui/x-date-pickers";
import { PickerValue } from "@mui/x-date-pickers/internals";
import { Dayjs } from "dayjs";
import React from "react";

const DateRangePicker = ({
  value,
  setValue,
}: {
  value: { startDate: Dayjs | null; endDate: Dayjs | null };
  setValue: Function;
}) => {
  const buttonLabel = React.useMemo(() => {
    const startDate = value.startDate?.format("DD/MM/YYYY") || "DD/MM/YYYY";
    const endDate = value.endDate?.format("DD/MM/YYYY") || "DD/MM/YYYY";

    return `${startDate} - ${endDate}`;
  }, [value]);

  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null,
  );

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDateChange = (name: string, newValue: Dayjs | null) => {
    setValue((prev: any) => {
      if (name === "endDate") {
        newValue = newValue?.hour(23).minute(59).second(59).clone() as Dayjs;
      }
      return {
        ...prev,
        [name]: newValue,
      };
    });
  };
  const open = Boolean(anchorEl);

  return (
    <>
      <Button
        variant="outlined"
        color="primary"
        size="small"
        onClick={handleClick}
        startIcon={<CalendarIcon />}
        sx={{ width: 230 }}
      >
        {buttonLabel}
      </Button>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Box display={"flex"} flexDirection={"row"}>
          <DateCalendar
            value={value.startDate}
            onChange={(newValue) => handleDateChange("startDate", newValue)}
          />
          <DateCalendar
            value={value.endDate}
            onChange={(newValue) => handleDateChange("endDate", newValue)}
          />
        </Box>
      </Popover>
    </>
  );
};

export default DateRangePicker;
